import { useEffect, useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import { getDateRange } from "../../../../../utils/DateUtils";
import { ApiError } from "../../../../components/Common/ApiError";
import { formatNumberWithTwoDecimals } from "../../../../../utils/FormatUtils";
import Api from "../../../../../constants/Api";
import { useTranslation } from "react-i18next";
import LoadingCenter from "../../../../components/Common/LoadingCenter";
import { Link } from "react-router-dom";
import ModalPage from "../../../../components/Common/Modal/ModalPage";
import CommissionHistory from "./CommissionHistory";

const CalculateCommission = (props) => {

    // refreshKey: muda quando um ajuste é salvo na tela do Pote e obriga este card a
    // buscar de novo, porque o valor corrigido muda o que o colaborador recebe.
    const { entityId, month, year, branchId, refreshKey, data: suppliedData } = props;
    const [showLoading, setShowLoading] = useState(false);
    const [loadedData, setLoadedData] = useState(0);
    const { t } = useTranslation();
    const [showHistory, setShowHistory] = useState(false);

    useEffect(() => {
        // No dashboard, os totais já vieram no mesmo cálculo do rateio. A busca individual
        // é mantida para quem reutiliza este componente fora daquela tela.
        if (suppliedData) {
            return;
        }
        setShowLoading(true);
        const dateRange = getDateRange(month, year);
        const params = branchId ? { branchId } : {};
        axiosInstance.get(`${Api.sales.visual_calculation}/commission/${entityId}/${dateRange.start}/${dateRange.end}`, { params })
            .then((resp) => {
                setLoadedData(resp.data);
            })
            .catch(error => ApiError(error))
            .finally(() => setShowLoading(false));
    }, [entityId, month, year, branchId, refreshKey, suppliedData]);

    const data = suppliedData || loadedData;

    return (
        <>
            <ModalPage
                title={t('details')}
                show={showHistory}
                setShow={setShowHistory}
                scrollable={true}
                child={
                    showHistory && <CommissionHistory entityId={entityId} month={month} year={year} />
                }
                size="lg"
                dialogClassName="commission-history-modal__dialog"
            />

            {
                (showLoading) ?
                    <LoadingCenter className={"fa-3x"} />
                    :
                    <>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <span>{t('gamification.pot_ordinary_commission')} </span>
                            <h6 className="mb-0">{t('currency_symbol')} {formatNumberWithTwoDecimals(data.commission)}</h6>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <span>{t('gamification.pot_reward')} </span>
                            <h6 className="mb-0 text-success">{t('currency_symbol')} {formatNumberWithTwoDecimals(data.potReward)}</h6>
                        </div>
                        {/* Só aparece para quem tem acordo. Zerado, seria mais uma linha
                            para ler sem dizer nada, e o valor do pote já é o mesmo do
                            relatório de comissão sem ela. */}
                        {Number(data.potBonus || 0) > 0 && (
                            <div className="d-flex align-items-center justify-content-between">
                                <span>{t('gamification.pot_bonus')} </span>
                                <h6 className="mb-0 text-success">{t('currency_symbol')} {formatNumberWithTwoDecimals(data.potBonus)}</h6>
                            </div>
                        )}
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <span className="text-primary">{t('gamification.score')} </span>
                            <h6 className="mb-0">{data.scoreTotal} <strong>{t('gamification.score_simplified')}</strong></h6>
                        </div>
                        <hr />
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <h4 className="mb-0">{t('total')}</h4>
                            <h4 className="mb-0 text-primary">{t('currency_symbol')} {formatNumberWithTwoDecimals(data.commissionTotal)}</h4>
                        </div>
                        <Link to={"#"} onClick={() => setShowHistory(true)} className={`btn btn-block btn-outline-primary`}>{t('to_detail')}</Link>
                    </>
            }
        </>
    )
}

export default CalculateCommission;
